import { Component, inject } from '@angular/core';
import { LayoutService } from '../services/layout.service';
import { MobileLayoutComponent } from './mobile/mobile-layout.component';
import { TabletLayoutComponent } from './tablet/tablet-layout.component';
import { LaptopLayoutComponent } from './laptop/laptop-layout.component';
import { MonitorLayoutComponent } from './monitor/monitor-layout.component';

@Component({
  selector: 'app-dashboard-shell',
  standalone: true,
  imports: [
    MobileLayoutComponent,
    TabletLayoutComponent,
    LaptopLayoutComponent,
    MonitorLayoutComponent,
  ],
  template: `
    @switch (layoutService.currentBreakpoint()) { @case ('mobile') {
    <app-mobile-layout />
    } @case ('smallTablet') {
    <app-mobile-layout />
    } @case ('tablet') {
    <app-tablet-layout />
    } @case ('smallDesktop') {
    <app-laptop-layout />
    } @default {
    <app-monitor-layout />
    } }
  `,
})
export class DashboardShellComponent {
  protected layoutService = inject(LayoutService);
}
